'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { RETURN_ORDER_TYPES } from 'shipping-and-returns/constants/returnOrderTypes'
import { cx } from 'utils/cx'

import styles from './ReturnDaysText.module.scss'
import texts from 'fukku/styles/texts.module.scss'

interface ReturnDaysTextProps {
	readonly maximumReturnDays: number
	readonly orderType?: string
	readonly wrapperComponent?: React.ElementType
	readonly isModal?: boolean
}
export function ReturnDaysText({
	maximumReturnDays,
	orderType,
	wrapperComponent: Wrapper = 'p',
	isModal = false,
}: ReturnDaysTextProps) {
	const { t } = useLabels()
	const { isSmall } = useResponsive()

	const returnDaysPlaceholder = {
		1: maximumReturnDays,
	}

	const boldProps = {
		...(isModal && {
			className: isSmall ? texts.bodySRegular : styles.daysBold,
		}),
	}

	return (
		<Wrapper
			className={cx(
				styles.text,
				isModal && (isSmall ? texts.bodyS : texts.bodyL),
				isModal && styles.modalText
			)}
		>
			{orderType === RETURN_ORDER_TYPES.STORE ? (
				<ClientLabel>
					{t('myPurchases.store.details.exchangesReturns.subtitle')}
				</ClientLabel>
			) : (
				<ClientLabel
					placeholderValues={returnDaysPlaceholder}
					boldProps={boldProps}
				>
					{t('myPurchases.online.details.returns.returnDays.bodycopy')}
				</ClientLabel>
			)}
		</Wrapper>
	)
}
